import gql from 'graphql-tag';

export const LabelsQuery = gql`
	query SpaceDirectoryLabelsQuery($start: Int) {
		teamLabels(start: $start, first: 200) {
			nodes {
				name
				id
			}
			pageInfo {
				hasNextPage
			}
		}
	}
`;
